import React from 'react';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { useTranslation } from 'react-i18next';

interface ResetButtonProps {
  onClick: () => void;
  label?: string;
  tooltip?: string;
  sx?: object;
}

const ResetButton: React.FC<ResetButtonProps> = ({ onClick, label, tooltip, sx }) => {
  const { t } = useTranslation('general');
  const buttonLabel = label ?? t('reset');
  const tooltipText = tooltip ?? t('reset_filters_search_status');
  
  return (
    <Tooltip title={tooltipText} arrow>
      <Button
        data-testid="invoice-reset-button"
        variant="outlined"
        color="primary"
        size="small"
        startIcon={<RestartAltIcon />}
        onClick={onClick}
        sx={{
          borderRadius: '16px',
          height: '32px',
          minWidth: '90px',
          fontWeight: 700,
          textTransform: 'none',
          boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
          transition: 'background 0.2s, color 0.2s, box-shadow 0.2s',
          alignSelf: 'center',
          '&:hover': {
            backgroundColor: 'rgba(58,128,226,0.08)',
            boxShadow: '0 4px 12px rgba(58,128,226,0.18)',
          },
          ...sx,
        }}
      >
        {buttonLabel}
      </Button>
    </Tooltip>
  );
};

export default ResetButton;
